import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { trim } from 'lodash';

const [
  LIST_CHANCE_FILES,
  LIST_CHANCE_FILES_SUCCESS,
  LIST_CHANCE_FILES_FAILURE,
] = createRequestActionTypes('chance/LIST_CHANCE_FILES');

export const listChanceFiles = createAction(
  LIST_CHANCE_FILES,
  (searchData) => ({ salesType: 'B', searchData }),
);
const listChanceFilesSaga = createRequestSaga(
  LIST_CHANCE_FILES,
  projectApi.getEstimateFiles,
);

const UNLOAD_FILES = 'chance/UNLOAD_FILES';
export const unloadFiles = createAction(UNLOAD_FILES);

export function* chanceFilesSaga() {
  yield takeLatest(LIST_CHANCE_FILES, listChanceFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const chanceFiles = handleActions(
  {
    [LIST_CHANCE_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        filePartnerNm: file.filePartnerNm,
        filePartnerUuid: file.filePartnerUuid,
        fileNm: trim(file.fileNm),
        fileUrl: file.fileUrl,
        prjNo: file.prjNo,
        prjUuid: file.prjUuid,
        cstNm: file.cstNm,
        fileRegDt: file.fileRegDt,
        fileCrtDt: file.fileCrtDt,
        fileCrtNm: file.fileCrtNm,
      })),
      error: null,
    }),
    [LIST_CHANCE_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_FILES]: () => initialState,
  },
  initialState,
);

export default chanceFiles;
